import * as R from "ramda";
import React, { Component } from "react";
import FlexView from "react-flexview";
import ToggleButton from "react-toggle-button";
import ModalContainer from "../../../modules/commons/ModalContainer";
import SimpleButton from "../../../modules/commons/SimpleButton";
import withFormGroup from "../../../modules/commons/withFormGroup";
import SimpleModal from "../../../modules/popup/SimpleModal";
import SimpleDDL from "../../../modules/SimpleDDL";
import SimpleInput from "../../../modules/SimpleInput";
import SimpleUploadImage from "../../../modules/upload/SimpleUploadImage";
import Api from "../../../Services/Api";
import { ACTIVITY_TYPE, Status } from "../../common/Constants";
import { mapToObjectDDL } from "../../common/mapper";

class MasterCabangModifying extends Component {
  constructor(props) {
    super(props);
    this.state = {
      provinceOptions: [],
      kotaOptions: [],
      kecamatanOptions: [],
      kelurahanOptions: [],
      wilayahOptions: [],
      dealerAhmOptions: []
    };
  }

  async componentDidMount() {
    console.log(this.props);
    const responses = await Promise.all([
      Api.create("NAGAMAS_MASTER_DATA").getAllProvince(),
      Api.create("NAGAMAS_MASTER_DATA").getAllBizpar({
        paramFilters: {
          bizparCategory: "WILAYAH_TYPE",
        },
      }),
      Api.create("NAGAMAS_MASTER_DATA").getAllBizpar({
        paramFilters: {
          bizparCategory: "AHM_DEALER_CODE",
        },
      }),
    ]);

    if (responses[0].ok) {
      this.setState((prevValue) => ({
        ...prevValue,
        provinceOptions: responses[0].data.data.map((option) =>
          mapToObjectDDL(option.provinceName, option.id)
        ),
      }));
    }

    if (responses[1].ok) {
      this.setState((prevValue) => ({
        ...prevValue,
        wilayahOptions: responses[1].data.data.map((option) =>
          mapToObjectDDL(option.value, option.key)
        ),
      }));
    }

    if (responses[2].ok) {
      this.setState((prevValue) => ({
        ...prevValue,
        dealerAhmOptions: responses[2].data.data.map((option) =>
          mapToObjectDDL(option.value, option.key)
        ),
      }));
    }

    if (R.equals(this.props.activityType, ACTIVITY_TYPE.UPDATE)) {
      const controls = this.props.controls;
      if (!R.isNil(controls.idProvince.value)) {
        this.fetchKotaOptions(controls.idProvince.value.value);
      }

      if (!R.isNil(controls.idKota.value)) {
        this.fetchKecamatanOptions(controls.idKota.value.value);
      }

      if (!R.isNil(controls.idKecamatan.value)) {
        this.fetchKelurahanOptions(controls.idKecamatan.value.value);
      }
    }
  }

  fetchKotaOptions = async (id) => {
    const response = await Api.create("NAGAMAS_MASTER_DATA").getAllCity(id);
    if (response.ok) {
      this.setState((prevValue) => ({
        ...prevValue,
        kotaOptions: response.data.data.map((option) =>
          mapToObjectDDL(option.kabKotName, option.kabKotId)
        ),
      }));
    }
  };

  fetchKecamatanOptions = async (id) => {
    const response = await Api.create("NAGAMAS_MASTER_DATA").getAllKecamatan(id);
    if (response.ok) {
      this.setState((prevValue) => ({
        ...prevValue,
        kecamatanOptions: response.data.data.map((option) =>
          mapToObjectDDL(option.kecamatanName, option.id)
        ),
      }));
    }
  };

  fetchKelurahanOptions = async (id) => {
    const response = await Api.create("NAGAMAS_MASTER_DATA").getAllKelurahan(id);
    if (response.ok) {
      this.setState((prevValue) => ({
        ...prevValue,
        kelurahanOptions: response.data.data.map((option) => ({
          ...mapToObjectDDL(`${option.zipcode} - ${option.kelurahanname}`, option.zipcode),
          kelurahanId: option.id,
        })),
      }));
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();
    if (this.props.validate()) {
      this.props.onSubmit(this.props.controls);
    }
  };

  handleChangeProvince = async (name, value) => {
    this.props.setValue("idKota", null);
    this.props.setValue("idKecamatan", null);
    this.props.setValue("kodePos", null);
    this.props.setValue(name, value);
    if (!R.isNil(value)) {
      this.fetchKotaOptions(value.value);
    }
  };

  handleChangeKota = async (name, value) => {
    this.props.setValue("idKecamatan", null);
    this.props.setValue("kodePos", null);
    this.props.setValue(name, value);
    if (!R.isNil(value)) {
      this.fetchKecamatanOptions(value.value);
    }
  };

  handleChangeKecamatan = async (name, value) => {
    this.props.setValue("kodePos", null);
    this.props.setValue(name, value);
    if (!R.isNil(value)) {
      this.fetchKelurahanOptions(value.value);
    }
  };

  render() {
    const { errors } = this.props;
    return (
      <SimpleModal
        title="Master Cabang"
        visible={this.props.visible}
        onClickClose={() => this.props.onClickClose()}
        content={
          <ModalContainer>
            <div className="grid grid-2x grid-mobile-none gap-15px">
              {this.renderForm(errors)}
              {this.renderForm1(errors)}
            </div>
            <br />
            <FlexView hAlignContent="right">
              <SimpleButton onClick={this.handleSubmit}>Simpan</SimpleButton>
              <SimpleButton type="button" secondary onClick={this.props.reset}>
                Clear
              </SimpleButton>
            </FlexView>
          </ModalContainer>
        }
      />
    );
  }

  renderForm(errors) {
    return (
      <div id="grid-1">
        <SimpleInput
          id="input_text_kode_cabang"
          name="kodeCabang"
          label="Kode Cabang"
          mandatory
          errorMessage={errors.kodeCabang}
          readOnly={R.equals(this.props.activityType, ACTIVITY_TYPE.UPDATE)}
          value={this.props.controls.kodeCabang.value}
          onChange={({ target }) => this.props.setValue(target.name, target.value)}
        />
        <SimpleInput
          id="input_text_dealerid"
          name="ahmDealerCode"
          label="Dealer ID"
          value={this.props.controls.ahmDealerCode.value}
          onChange={({ target }) => this.props.setValue(target.name, target.value)}
        />
        <SimpleDDL
            id="ddl_dealer_ahm"
            label="Kode Dealer AHM yang Bisa Diakses"
            name="listAhmDealer"
            box="multiselect"
            options={this.state.dealerAhmOptions}
            value={this.props.controls?.listAhmDealer?.value}
           onChange={(value, { name }) => {
             this.props.setValue(name, value);
           }}
        />
        <SimpleInput
          id="input_text_nama_dealer"
          name="namaDealer"
          label="Nama Dealer"
          mandatory
          errorMessage={errors.namaDealer}
          value={this.props.controls.namaDealer.value}
          onChange={({ target }) => this.props.setValue(target.name, target.value)}
        />
        <SimpleInput
          id="input_text_nama_pt"
          name="namaPT"
          label="Nama PT"
          value={this.props.controls.namaPT.value}
          onChange={({ target }) => this.props.setValue(target.name, target.value)}
        />
        <SimpleInput
          id="input_text_alamat"
          name="alamat"
          label="Alamat"
          value={this.props.controls.alamat.value}
          onChange={({ target }) => this.props.setValue(target.name, target.value)}
        />
        <div>
          <h4 className="txt-site txt-11 txt-main">Coordinate</h4>
          <FlexView style={{ gap: "10px" }}>
            <SimpleInput
              placeholder="Lat"
              id="input_text_latitude"
              name="latitude"
              value={this.props.controls.latitude.value}
              onChange={({ target }) => this.props.setValue(target.name, target.value)}
            />
            <SimpleInput
              placeholder="Long"
              id="input_text_longitude"
              name="longitude"
              value={this.props.controls.longitude.value}
              onChange={({ target }) => this.props.setValue(target.name, target.value)}
            />
          </FlexView>
        </div>
        <SimpleDDL
          id="select_options_provinsi"
          name="idProvince"
          label="Provinsi"
          box="search"
          isClearable
          options={this.state.provinceOptions}
          value={this.props.controls.idProvince.value}
          onChange={(value, { name }) => this.handleChangeProvince(name, value)}
        />
        <SimpleDDL
          id="select_options_kota"
          name="idKota"
          label="Kota"
          box="search"
          isClearable
          readOnly={
            R.isNil(this.props.controls.idProvince.value) ||
            R.isEmpty(this.props.controls.idProvince.value)
          }
          options={this.state.kotaOptions}
          value={this.props.controls.idKota.value}
          onChange={(value, { name }) => this.handleChangeKota(name, value)}
        />
        <SimpleDDL
          id="select_options_kecamatan"
          name="idKecamatan"
          label="Kecamatan"
          box="search"
          isClearable
          readOnly={
            R.isNil(this.props.controls.idKota.value) || R.isEmpty(this.props.controls.idKota.value)
          }
          options={this.state.kecamatanOptions}
          value={this.props.controls.idKecamatan.value}
          onChange={(value, { name }) => this.handleChangeKecamatan(name, value)}
        />
        <SimpleDDL
          id="select_options_kode_pos"
          name="kodePos"
          label="Kode Pos"
          box="search"
          isClearable
          readOnly={
            R.isNil(this.props.controls.idKecamatan.value) ||
            R.isEmpty(this.props.controls.idKecamatan.value)
          }
          options={this.state.kelurahanOptions}
          value={this.props.controls.kodePos.value}
          onChange={(value, { name }) => this.props.setValue(name, value)}
        />
        <SimpleInput
          id="text_input_email"
          name="email"
          label="Email"
          value={this.props.controls.email.value}
          onChange={({ target }) => this.props.setValue(target.name, target.value)}
        />
        <SimpleInput
          id="text_input_mdid"
          name="kodeMD"
          label="MD ID"
          value={this.props.controls.kodeMD.value}
          onChange={({ target }) => this.props.setValue(target.name, target.value)}
        />
        <SimpleInput
          id="text_input_npwp"
          name="npwp"
          label="NPWP"
          value={this.props.controls.npwp.value}
          onChange={({ target }) => this.props.setValue(target.name, target.value)}
        />
      </div>
    );
  }

  renderForm1(errors) {
    return (
      <div id="grid-2">
        <SimpleDDL
          id="select_options_wilayah"
          name="idWilayah"
          label="Wilayah"
          box="search"
          mandatory
          errorMessage={errors.idWilayah}
          options={this.state.wilayahOptions}
          value={this.props.controls.idWilayah.value}
          onChange={(value, { name }) => this.props.setValue(name, value)}
        />
        <SimpleInput
          id="text_input_phone_bengkel"
          name="phoneBengkel"
          label="Phone Bengkel"
          box="onlyNumber"
          maxLength={14}
          value={this.props.controls.phoneBengkel.value}
          onChange={({ target }) => this.props.setValue(target.name, target.value)}
        />
        <SimpleInput
          id="text_input_phone_showroom"
          name="phoneShowroom"
          label="Phone Showroom"
          box="onlyNumber"
          maxLength={14}
          value={this.props.controls.phoneShowroom.value}
          onChange={({ target }) => this.props.setValue(target.name, target.value)}
        />
        <SimpleInput
          id="text_input_phone_crm"
          name="phoneCRM"
          label="Phone CRM"
          box="onlyNumber"
          maxLength={14}
          value={this.props.controls.phoneCRM.value}
          onChange={({ target }) => this.props.setValue(target.name, target.value)}
        />
        <SimpleInput
          id="text_input_facebook"
          name="facebookName"
          label="Facebook"
          value={this.props.controls.facebookName.value}
          onChange={({ target }) => this.props.setValue(target.name, target.value)}
        />
        <SimpleInput
          id="text_input_instagram"
          name="instagramName"
          label="Instagram"
          value={this.props.controls.instagramName.value}
          onChange={({ target }) => this.props.setValue(target.name, target.value)}
        />
        <SimpleUploadImage
          id="input_upload_foto_gedung"
          name="fotoGedungUrl"
          label="Foto Gedung"
          value={this.props.controls.fotoGedungUrl.value}
          onChange={(value, name) => this.props.setValue(name, value)}
        />
        <SimpleUploadImage
          id="input_upload_stempel"
          name="fotoStampelUrl"
          label="Stempel"
          mandatory
          errorMessage={errors.fotoStampelUrl}
          value={this.props.controls.fotoStampelUrl.value}
          onChange={(value, name) => this.props.setValue(name, value)}
        />
        <SimpleUploadImage
          id="input_upload_materai"
          name="fotoMateraiUrl"
          label="Materai"
          mandatory
          errorMessage={errors.fotoMateraiUrl}
          value={this.props.controls.fotoMateraiUrl.value}
          onChange={(value, name) => this.props.setValue(name, value)}
        />
        <SimpleUploadImage
          id="input_upload_kwitansi"
          name="fotoTemplateKwitansiUrl"
          label="Template Kwitansi"
          mandatory
          errorMessage={errors.fotoTemplateKwitansiUrl}
          value={this.props.controls.fotoTemplateKwitansiUrl.value}
          onChange={(value, name) => this.props.setValue(name, value)}
        />
        <ToggleButton
          value={R.equals(this.props.controls.status.value, Status.ACTIVE)}
          onToggle={(value) =>
            this.props.setValue("status", !value ? Status.ACTIVE : Status.INACTIVE)
          }
        />
      </div>
    );
  }
}

export default withFormGroup(MasterCabangModifying);
